import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import Currency from '@prisjakt/ui-currency';
import { FontEmphasis, FontWeight } from '@prisjakt/ui/text/variants';

import {
  PriceDisplay,
  PriceDisplayEnum,
} from 'src/components/price-list/types';

import * as S from './styles';
import { Maybe } from 'src/types';

type Props = {
  className?: string;
  compact?: boolean;
  emphasis?: FontEmphasis;
  exclShipping: number;
  shippingInfo: Maybe<number> | undefined;
  priceDisplay: PriceDisplay;
};

export const ShippingLabel = ({
  className,
  compact = false,
  emphasis = FontEmphasis.MEDIUM,
  exclShipping,
  shippingInfo,
  priceDisplay,
  ...rest
}: Props) => {
  const { t } = useContext(AppContext);

  let shippingValue: string;

  if (shippingInfo === undefined || shippingInfo === null) {
    shippingValue = t('product', 'price.unknown-shipping');
  } else if (shippingInfo === 0) {
    shippingValue = t('product', 'price.free-shipping');
  } else {
    shippingValue =
      priceDisplay === PriceDisplayEnum.PRICE_INCLUDES_SHIPPING
        ? t('product', 'price.excluding-shipping', {
            price: <Currency key="currency" price={exclShipping} />,
          })
        : t('product', 'price.including-shipping', {
            price: (
              <Currency key="currency" price={exclShipping + shippingInfo} />
            ),
          });
  }

  return (
    <S.ShippingLabel
      className={className}
      value={shippingValue}
      emphasis={emphasis}
      compact={compact}
      weight={FontWeight.NORMAL}
      {...rest}
    />
  );
};
